export * from './TenantedApplicationConfig';
